import type { ChartData } from "@/stores/comparasion";

export default function (breakdown: string, data: ChartData[]): string[] {
  const scope1: string = "#25B778";
  const scope2: string = "#3800FF";
  const scope3: string = "#7243FD";

  let backgrounds: string[] = [];
  switch (breakdown) {
    case "SCOPE":
      data.map((v) => {
        const key = v.name || v.label;
        if (key === "1") backgrounds.push(scope1);
        if (key === "2") backgrounds.push(scope2);
        if (key === "3") backgrounds.push(scope3);
        if (key === "FLAG") backgrounds.push('#27ae60');
        if (key === "BIOGENIC") backgrounds.push('#d6675d');
      });
      break;
    case "EMISSION_GROUP":
      backgrounds = [
        "#EE7E4B",
        "#1F80C8",
        "#F4C01E",
        "#25B778",
        "#7243FD",
        "#3800FF",
        "#30C0D8",
      ];
      break;
    /*        case 'EMISSION_SOURCE':
                    backgrounds = ['#EE7E4B', '#1F80C8', '#F4C01E', '#25B778', '#7243FD', '#3800FF', '#30C0D8']
                    break

         */
    default:
      backgrounds = [
        "#25B778",
        "#3800FF",
        "#7243FD",
        "#25CCF7",
        "#FD7272",
        "#54a0ff",
        "#00d2d3",
        "#1abc9c",
        "#2ecc71",
        "#3498db",
        "#9b59b6",
        "#34495e",
        "#16a085",
        "#27ae60",
        "#2980b9",
        "#8e44ad",
        "#2c3e50",
        "#f1c40f",
        "#e67e22",
        "#e74c3c",
        "#ecf0f1",
        "#95a5a6",
        "#f39c12",
        "#d35400",
        "#c0392b",
        "#bdc3c7",
        "#7f8c8d",
        "#55efc4",
        "#81ecec",
        "#74b9ff",
        "#a29bfe",
        "#dfe6e9",
        "#00b894",
        "#00cec9",
        "#0984e3",
        "#6c5ce7",
        "#ffeaa7",
        "#fab1a0",
        "#ff7675",
        "#fd79a8",
        "#fdcb6e",
        "#e17055",
        "#d63031",
        "#feca57",
        "#5f27cd",
        "#54a0ff",
        "#01a3a4",
      ];
  }

  return backgrounds;
}
